(() => {
  // @ts-ignore
  function throttle(fn, delay) {
  let lastCall = 0;
  // @ts-ignore
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

  class DesktopNavigation extends HTMLElement {
    constructor() {
      super();
      this.openingTimeout = null;
      this.currentMegaMenu = null;
    }
    
    connectedCallback() {
      this.addEventListener("mouseenter", this.onMouseEnter.bind(this), true);
      this.addEventListener("click", this.onClick.bind(this), true);

      document.addEventListener("shopify:block:select", (event) => {
        // @ts-ignore
        this.openDropdown(event.target.parentElement);
      });

      document.addEventListener("shopify:block:deselect", (event) => {
        // @ts-ignore
        this.closeDropdown(event.target.parentElement);
      });
    }

    // @ts-ignore
    onMouseEnter(event) {
      const target = event.target.closest(".has-dropdown");
      if (!target || !this.contains(target)) return;
      if (event.relatedTarget !== null && event.target === target) {
        this.openDropdown(target);
      }
    }

    // @ts-ignore
    onClick(event) {
      const target = event.target.closest(".header__linklist-link[aria-expanded], .nav-dropdown__link[aria-expanded]");
      if (!target || !this.contains(target)) return;

      // Only apply click to open on touch devices
      if (window.matchMedia("(hover: hover)").matches || target.getAttribute("aria-expanded") === "true") {
        return;
      }

      event.preventDefault();
      this.openDropdown(target.parentElement);
    }

    // @ts-ignore
    openDropdown(parentElement) {
      const menuItem = parentElement.querySelector("[aria-controls]");
      const dropdown = parentElement.querySelector(`#${menuItem.getAttribute("aria-controls")}`);
      this.currentMegaMenu = dropdown.classList.contains("mega-menu") ? dropdown : null;

      let openingTimeout = setTimeout(() => {
        if (menuItem.getAttribute("aria-expanded") === "true") {
          return;
        }

        menuItem.setAttribute("aria-expanded", "true");
        dropdown.removeAttribute("hidden");

        if (dropdown.classList.contains("mega-menu") && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          const items = Array.from(dropdown.querySelectorAll(".mega-menu__column, .mega-menu__image-push"));
          items.forEach((item) => {
            // @ts-ignore
            item.getAnimations().forEach((a) => a.cancel());
            item.style.opacity = 0;
          });

          items.forEach((item, index) => {
            item.animate(
              {
                opacity: [0, 1],
                transform: ["translateY(20px)", "translateY(0)"]
              },
              {
                duration: 250,
                delay: 100 + 60 * index,
                easing: "cubic-bezier(0.65, 0, 0.35, 1)",
                fill: "forwards"
              }
            );
          });
        }

        // @ts-ignore
        const leaveListener = (event) => {
          if (event.relatedTarget !== null) {
            this.closeDropdown(parentElement);
            parentElement.removeEventListener("mouseleave", leaveListener);
          }
        };

        parentElement.addEventListener("mouseleave", leaveListener);
        this.openingTimeout = null;

        this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:open", { bubbles: true }));
      }, 100);

      parentElement.addEventListener("mouseleave", () => {
        if (openingTimeout) {
          clearTimeout(openingTimeout);
        }
      }, { once: true });

      this.openingTimeout = openingTimeout;
    }

    // @ts-ignore
    closeDropdown(parentElement) {
      const menuItem = parentElement.querySelector("[aria-controls]");
      const dropdown = parentElement.querySelector(`#${menuItem.getAttribute("aria-controls")}`);

      requestAnimationFrame(() => {
        dropdown.classList.add("is-closing");
        menuItem.setAttribute("aria-expanded", "false");

        const delay = (dropdown.classList.contains("mega-menu") && this.currentMegaMenu !== dropdown) ? 250 : 0;

        setTimeout(() => {
          dropdown.setAttribute("hidden", "");
          dropdown.classList.remove("is-closing");
        }, delay);

        this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:close", { bubbles: true }));
      });
    }
  }

  window.customElements.define("desktop-navigation", DesktopNavigation);

  // js/custom-element/section/header/store-header.js
  class StoreHeader extends HTMLElement {
    connectedCallback() {
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this));
        this.resizeObserver.observe(this);
        // @ts-ignore
        this.resizeObserver.observe(this.querySelector(".header__wrapper"));
      }

      if (this.isTransparent) {
        
        this.isTransparencyDetectionLocked = false;
        // 替代 delegate
        this.addEventListener("desktop-nav:dropdown:open", () => this.lockTransparency = true);
        this.addEventListener("desktop-nav:dropdown:close", () => this.lockTransparency = false);
        this.addEventListener("mouseenter", this._checkTransparentHeader.bind(this), true);
        this.addEventListener("mouseleave", this._checkTransparentHeader.bind(this));

        // 替代 rootDelegate
        document.documentElement.addEventListener("mobile-nav:open", () => this.lockTransparency = true);
        document.documentElement.addEventListener("mobile-nav:close", () => this.lockTransparency = false);

        
        if (this.isSticky) {
          this._checkTransparentHeader();
          this._onWindowScrollListener = throttle(this._checkTransparentHeader.bind(this), 10);
          window.addEventListener("scroll", this._onWindowScrollListener);
        }
      }
    }

    disconnectedCallback() {
      // @ts-ignore
      super.disconnectedCallback();
      if (window.ResizeObserver) {
        // @ts-ignore
        this.resizeObserver.disconnect();
      }
      if (this.isTransparent && this.isSticky) {
        // @ts-ignore
        window.removeEventListener("scroll", this._onWindowScrollListener);
      }
    }
    get isSticky() {
      return this.hasAttribute("sticky");
    }
    get isTransparent() {
      return this.hasAttribute("transparent");
    }
    get transparentHeaderThreshold() {
      return 25;
    }
    // @ts-ignore
    set lockTransparency(value) {
      this.isTransparencyDetectionLocked = value;
      this._checkTransparentHeader();
    }
    // @ts-ignore
    _updateCustomProperties(entries) {
      // @ts-ignore
      entries.forEach((entry) => {
        if (entry.target === this) {
          const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
          document.documentElement.style.setProperty("--header-height", `${height}px`);

          
        }
        if (entry.target.classList.contains("header__wrapper")) {
          const heightWithoutNav = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
          document.documentElement.style.setProperty("--header-height-without-bottom-nav", `${heightWithoutNav}px`);
        }
      });
    }
    // @ts-ignore
    _checkTransparentHeader(event) {
      if (this.isTransparencyDetectionLocked || window.scrollY > this.transparentHeaderThreshold || event && event.type === "mouseenter") {
        this.classList.remove("header--transparent");
      } else {
        this.classList.add("header--transparent");
      }
    }
  };
  window.customElements.define("store-header", StoreHeader);

  function removeTrapFocus(elementToFocus = null) {
    // @ts-ignore
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    // @ts-ignore
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    // @ts-ignore
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    // @ts-ignore
    if (elementToFocus) elementToFocus.focus();
  }
  // @ts-ignore
  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  const trapFocusHandlers = {};

  // @ts-ignore
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    // @ts-ignore
    trapFocusHandlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;

      // @ts-ignore
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    // @ts-ignore
    trapFocusHandlers.focusout = function () {
      // @ts-ignore
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    // @ts-ignore
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    // @ts-ignore
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    // @ts-ignore
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }

  class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  // @ts-ignore
  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      // @ts-ignore
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  // @ts-ignore
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  // @ts-ignore
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      // @ts-ignore
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  // @ts-ignore
  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    // @ts-ignore
    this.mainDetailsToggle.classList.remove('menu-opening');
    // @ts-ignore
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    // @ts-ignore
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    // @ts-ignore
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    // @ts-ignore
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      // @ts-ignore
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  // @ts-ignore
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  // @ts-ignore
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  // @ts-ignore
  closeAnimation(detailsElement) {
    // @ts-ignore
    let animationStart;

    // @ts-ignore
    const handleAnimation = (time) => {
      // @ts-ignore
      if (animationStart === undefined) {
        animationStart = time;
      }

      // @ts-ignore
      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  // @ts-ignore
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      // @ts-ignore
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      // @ts-ignore
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      // @ts-ignore
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  // @ts-ignore
  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        // @ts-ignore
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);
})();


// var previousScrollTop = 0;
// var isHeaderVisible = true;
// var header = document.querySelector('.header_all');
// var announcement = document.querySelector('.announcement_all');

// window.addEventListener('scroll', function() {
//   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
//   if (scrollTop > previousScrollTop) {
//     // 向下滚动
//     if (scrollTop > 100 && isHeaderVisible) {
//       // @ts-ignore
//       const headerHeight = header.offsetHeight;
//       const stickyForm = document.querySelector('.product-sticky-form');
//       // @ts-ignore
//       header.style.transform = "translateY(-" + headerHeight + "px)";
//       // @ts-ignore
//       header.classList.add('down');
//       // @ts-ignore
//       header.classList.remove('up');

//       // if (announcement) {
//       //   var announcementHeight = announcement.offsetHeight;
//       //   announcement.style.transform = "translateY(-" + announcementHeight + "px)";
//       //   header.style.transform = "translateY(-" + (announcementHeight + headerHeight) + "px)";
//       // } else {
//       // }
//       isHeaderVisible = false;
//       if(stickyForm) {
//         // @ts-ignore
//         stickyForm.style.transform = "translateY(-" + headerHeight + "px)";
//       }
//     }
//   } else {
//     // 向上滚动
//     if (!isHeaderVisible) {
//       if (announcement) {
//         // @ts-ignore
//         announcement.style.transform = 'translateY(0px)';
//       }
//       const stickyForm = document.querySelector('.product-sticky-form');
//       // @ts-ignore
//       header.style.transform = 'translateY(0px)';
//       // @ts-ignore
//       header.classList.add('up');
//       // @ts-ignore
//       header.classList.remove('down');
//       isHeaderVisible = true;
//       if(stickyForm) {
//         // @ts-ignore
//         const headerHeight = document.querySelector('.header_all').offsetHeight;
//         // @ts-ignore
//         stickyForm.style.transform = 'translateY(-1px)';
//       }
//     }
//   }
//   previousScrollTop = scrollTop;
// });

